import { useCallback, useEffect, useState } from 'react';
import {
  getAdminSession,
  loginAdmin,
  logoutAdmin,
  type AdminSession,
} from '@workspace/api-client-react';

export type AuthState = {
  admin: AdminSession | null;
  isLoading: boolean;
  isAuthenticated: boolean;
  login: (username: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
};

export function useAuth(): AuthState {
  const [admin, setAdmin] = useState<AdminSession | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    getAdminSession()
      .then((payload) => {
        if (!cancelled) {
          setAdmin(payload.admin ?? null);
          setIsLoading(false);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setAdmin(null);
          setIsLoading(false);
        }
      });
    return () => { cancelled = true; };
  }, []);

  const login = useCallback(async (username: string, password: string) => {
    const payload = await loginAdmin({ username, password });
    setAdmin(payload.admin);
  }, []);
  const logout = useCallback(async () => {
    await logoutAdmin();
    setAdmin(null);
  }, []);

  return { admin, isLoading, isAuthenticated: Boolean(admin), login, logout };
}